import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "16",
  height: "16",
  fill: "currentColor",
  class: "qi-802"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", { d: "M8 0a8.031 8.031 0 0 0-1.065.079 7.992 7.992 0 0 0-.354 15.788h.001A7.952 7.952 0 0 0 8 16 8 8 0 0 0 8 0zm0 15.5a6.836 6.836 0 0 1-.725-.04A24.01 24.01 0 0 0 8.5 7.5 25.697 25.697 0 0 0 7.593.514C7.734.504 7.868.5 8 .5a7.5 7.5 0 0 1 0 15z" }, null, -1)
const _hoisted_3 = [
  _hoisted_2
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3))
}
export default { render: render }